import * as React from 'react';
import { Image } from '@zoopla/image';

import { ListingFeatureList } from '@zoopla/listings/features';
import { ListingImage } from '@zoopla/listings/image';
import { SimilarListingCardProps } from './SimilarListingCards.types';
import { fontGroups } from '@zoopla-eng/zds/themes';
import {
    agencyLogoStyle,
    cardsContainerStyle,
    cardHeaderStyle,
    similarListingImageStyle,
    cardDetailsStyle,
    metaCardStyle,
    styledCardStyle,
    styledLinkStyle,
    priceStyle,
    agencyLogoImageStyle
} from './SimilarListingCards.styles.css';
import { Box } from '@zoopla-eng/zds/box';

type SimilarListingCardsProps = {
    listings: SimilarListingCardProps[];
    metaCardAfter?: React.ReactElement;
    trackSimilarListingClick: (index: number) => void;
    cardContainerRef?: React.Ref<HTMLDivElement>;
    onScroll?: () => void;
};

export const SimilarListingCards = ({
    listings,
    metaCardAfter,
    trackSimilarListingClick,
    cardContainerRef,
    onScroll
}: SimilarListingCardsProps) => {
    return (
        <div
            className={cardsContainerStyle}
            onScroll={onScroll}
            ref={cardContainerRef}
        >
            {listings.map((listing, index) => {
                const {
                    displayAddress,
                    branch,
                    featurePreview,
                    imagePreview,
                    price,
                    pricingQualifier,
                    title,
                    listingDetailUri,
                    statusSummary
                } = listing;

                return listingDetailUri ? (
                    <a
                        className={styledLinkStyle}
                        data-testid="similar-property-card"
                        href={listingDetailUri}
                        key={`${listing.listingId}-${index}`}
                        onClick={() => trackSimilarListingClick(index)}
                    >
                        <div className={styledCardStyle}>
                            <div className={similarListingImageStyle}>
                                <ListingImage
                                    image={imagePreview}
                                    badgeText={statusSummary}
                                />
                            </div>
                            <div className={cardDetailsStyle}>
                                <div className={cardHeaderStyle}>
                                    <div>
                                        {pricingQualifier && (
                                            <p className={fontGroups.knife}>
                                                {pricingQualifier}
                                            </p>
                                        )}
                                        <p
                                            className={`${priceStyle} ${fontGroups.mug}`}
                                            data-testid={`price-${index}`}
                                        >
                                            {price}
                                        </p>
                                    </div>
                                    {branch?.logoUrl ? (
                                        <div className={agencyLogoStyle}>
                                            <Image
                                                src={branch?.logoUrl}
                                                alt={`Marketed by ${branch?.name}`}
                                                className={agencyLogoImageStyle}
                                            />
                                        </div>
                                    ) : null}
                                </div>
                                <ListingFeatureList features={featurePreview} />
                                {title && (
                                    <Box pt="S200">
                                        <h3 className={fontGroups.ladle}>
                                            {title}
                                        </h3>
                                    </Box>
                                )}
                                <p className={fontGroups.knife}>
                                    {displayAddress}
                                </p>
                            </div>
                        </div>
                    </a>
                ) : null;
            })}
            {Boolean(metaCardAfter) && (
                <div className={metaCardStyle} data-testid="meta-card">
                    {metaCardAfter}
                </div>
            )}
        </div>
    );
};
